exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.icon[data-v-777413b6] {\n  /* filter: invert(99%) sepia(99%) saturate(1%) hue-rotate(243deg) brightness(105%) contrast(100%); */\n  color: #fff;\n  width: 40px;\n  height: 40px;\n}\n.title[data-v-777413b6] {\n  font-size: small;\n  font-weight: bold;\n  color: #fff;\n}\n.subtitle[data-v-777413b6] {\n  font-size: smaller;\n  color: #fff;\n}\n.tabtitle[data-v-777413b6] {\n  font-size: larger;\n  color: #fff;\n  margin-right: 10px;\n  margin-left: 10px;\n}\n.tabButton[data-v-777413b6] {\n  cursor: pointer;\n}\n", ""]);

// exports
